import '../../sass/form/index.scss';
import React from 'react';
import {render} from 'react-dom';
import installGlobalErrorReporter from '@common/helpers/installGlobalErrorReporter';

installGlobalErrorReporter('resume-form');
import {Provider} from 'react-redux';
import configureStore from '@core/reducers/configureStore';
import PreloaderReducer from '@common/reducers/PreloaderReducer';
import ResumeOptionsReducer from './reducers/ResumeOptionsReducer';
import UserReducer from '@core/reducers/UserReducer';
import ModalReducer from '@core/reducers/ModalReducer';
import SiteReducer from '@core/reducers/SiteReducer';
import FileReducer from '@form/reducers/FileReducer';
import CouponReducer from './reducers/CouponReducer';
import ErrorBoundary from '@core/components/ErrorBoundary';
import Index from './components/Index';
import {siteSetData} from '@core/actions/SiteActions';
import {NotificationContainer} from '../common/Notification';
import {OverlayContainer} from '../common/Overlay';

const store = configureStore({
    preloader: PreloaderReducer,
    resumeOptions: ResumeOptionsReducer,
    user: UserReducer,
    modal: ModalReducer,
    file: FileReducer,
    coupon: CouponReducer,
    site: SiteReducer,
});

const rootElement = document.getElementById('resume-form-app');
const dataset = rootElement.dataset;

store.dispatch(siteSetData({
    lang: dataset.lang,
    parentSite: dataset.parentSite,
    parentSiteEmail: dataset.parentSiteEmail,
    recaptchaSiteKey: dataset.recaptchaSiteKey,
}));

render(
    <Provider store={store}>
        <ErrorBoundary>
            <Index />
            <NotificationContainer />
            <OverlayContainer />
        </ErrorBoundary>
    </Provider>,
    rootElement,
);
